export default __webpack_public_path__ + "static/media/Cosmo-Logo_Black.12084f73.png";